import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import cn from 'classnames';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NestableItem = function NestableItem(_ref) {
  var item = _ref.item,
      isCopy = _ref.isCopy,
      options = _ref.options,
      index = _ref.index,
      isAndItem = _ref.isAndItem,
      isOrItem = _ref.isOrItem,
      isDraggableItem = _ref.isDraggableItem,
      singleRow = _ref.singleRow;
  var dragItem = options.dragItem,
      renderItem = options.renderItem,
      handler = options.handler,
      childrenProp = options.childrenProp;
  var isCollapsed = options.isCollapsed(item);
  var isDragging = !isCopy && dragItem && dragItem.id === item.id;
  var hasChildren = item[childrenProp] && item[childrenProp].length > 0;
  var Handler;
  var isOrGroup = item.element.type === 'group' && (item.element.condition === '' || item.element.condition === false);
  var isAndGroup = item.element.type === 'group' && !(item.element.condition === '' || item.element.condition === false);
  var itemProps = {
    className: cn("nestable-item".concat(isCopy ? '-copy' : ''), "nestable-item".concat(isCopy ? '-copy' : '', "-").concat(item.id), "nestable-item-type-".concat(item.element.type), {
      'is-or-group': isOrGroup,
      'is-and-group': isAndGroup,
      'is-and-filter': item.element.type === 'filter' && isAndItem,
      'is-or-filter': item.element.type === 'filter' && isOrItem
    }, {
      'is-dragging': isDragging
    })
  };
  var rowProps = {};
  var handlerProps = {};

  if (!isCopy) {
    if (dragItem) {
      rowProps = _objectSpread(_objectSpread({}, rowProps), {}, {
        onMouseEnter: function onMouseEnter(e) {
          return options.onMouseEnter(e, item);
        }
      });
    } else {
      handlerProps = _objectSpread(_objectSpread({}, handlerProps), {}, {
        draggable: isDraggableItem !== false,
        onDragStart: function onDragStart(e) {
          return options.onDragStart(e, item);
        }
      });
    }
  }

  if (handler) {
    Handler = /*#__PURE__*/React.createElement("span", _extends({
      className: "nestable-item-handler"
    }, handlerProps), handler); // Handler = React.cloneElement(handler, handlerProps);
  } else {
    rowProps = _objectSpread(_objectSpread({}, rowProps), handlerProps);
  }

  var childLength = item[childrenProp].length;
  var childClass = 'single';
  if (childLength === 0) childClass = 'empty';else if (childLength > 1) childClass = 'multiple';
  return /*#__PURE__*/React.createElement("li", itemProps, /*#__PURE__*/React.createElement("div", _extends({
    className: "nestable-item-name nestable-item-name--".concat(item.element.type, " ")
  }, rowProps), renderItem({
    item: item,
    handler: Handler,
    index: index
  })), hasChildren && item.element.type === 'group' && !isCollapsed && /*#__PURE__*/React.createElement("ol", {
    className: "nestable-list nestable-child-count-".concat(childClass, " ")
  }, item[childrenProp].map(function (currentitem, i) {
    return /*#__PURE__*/React.createElement(NestableItem, {
      key: i,
      index: i,
      isAndItem: isAndGroup,
      isCopy: isCopy,
      isOrItem: isOrGroup,
      item: currentitem,
      options: options,
      singleRow: singleRow
    });
  })));
};

export default NestableItem;
//# sourceMappingURL=NestableItem.js.map
